<template>
  <div v-if="FormDataOne" class="language_ability">
    <div class="tabs">
      <span></span>语言能力
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form v-if="isForm" :inline="true" :label-position="labelPosition" label-width="100px" :rules="ruleFormDataOne"
      ref="ruleFormDataOne" :model="FormDataOne">
      <el-form-item label="母 语" prop="mother_tongue">
        <el-select v-model="FormDataOne.mother_tongue" placeholder="请选择" :disabled="isDis">
          <el-option v-for="(item) in mother_tongueList" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="从事年限" prop="region">
        <el-select v-model="FormDataOne.region" placeholder="请选择" :disabled="isDis">
          <el-option label="1年以下" value=1></el-option>
          <el-option label="1-3年" value=2></el-option>
          <el-option label="3-5年" value=3></el-option>
          <el-option label="5-10年" value=4></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="擅长语言" prop="language">
        <el-select v-model="FormDataOne.language" placeholder="请选择" :disabled="isDis" multiple :multiple-limit="3"
          @change="handeleLanguage">
          <el-option v-for="(item) in mother_tongueList" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="擅长领域" prop="domain_code">
        <el-select v-model="FormDataOne.domain_code" placeholder="请选择" :disabled="isDis" multiple :multiple-limit="3"
          @change="handeleDomainCode">
          <el-option v-for="(item) in domainList" :key="item.id" :label="item.dataValue" :value="item.dataValue">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="isLanguage" class="language_ability_isdsi">
      <div class="left">
        <div class="left_top">
          <div style="width:100px"><i>*</i>母语</div>
          <div v-if="FormDataOne.mother_tongue" class="language_ability_isdsi_wrp">
            <span>{{FormDataOne.mother_tongue}}</span>

          </div>

        </div>
        <div class="left_bottom">
          <div style="width:100px"><i>*</i>擅长语言</div>

          <div v-if="FormDataOne.language.length" class="language_ability_isdsi_wrp">
            <span v-for="(item) in FormDataOne.language" :key="item">{{item}}</span>

          </div>
        </div>
      </div>
      <div class="right">
        <div class="right_top">
          <div style="width:100px"><i>*</i>从事年限</div>
          <div v-if="FormDataOne.region" class="language_ability_isdsi_wrp">
            <span>{{FormDataOne.region}}</span>
          </div>

        </div>
        <div class="right_bottom">
          <div style="width:100px"><i>*</i>擅长领域</div>
          <div v-if="FormDataOne.domain_code.length" class="language_ability_isdsi_wrp">
            <span v-for="(item) in FormDataOne.domain_code" :key="item">{{item}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
    isLanguage () {
      if (!this.isDis) {
        return false
      } else {
        return this.FormDataOne.mother_tongue ? true : false
      }
    },
    isForm () {
      if (this.FormDataOne.mother_tongue) {
        console.log(this.FormDataOne.mother_tongue, "----------------")
        if (!this.isDis) {
          return true
        } else {
          return false
        }

      } else {
        return true
      }

    },
  },
  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          this.certificateUrls = newVale.certificateUrls
          switch (newVale.translationTime) {
            case 1:
              newVale.translationTime = "1年以下"
              break;
            case 2:
              newVale.translationTime = "1-3年"
              break;
            case 3:
              newVale.translationTime = "3-5年"
              break;
            case 4:
              newVale.translationTime = "5-10年"
              break;
            default:
              break;
          }
          let dataOptions, languageC
          this.FormDataOne.mother_tongue = newVale.motherTongue // 母语
          dataOptions = newVale.dataOptions // 领域
          languageC = newVale.languages // 语言
          this.FormDataOne.region = newVale.translationTime // 年限
          if (dataOptions) {
            dataOptions.forEach(item => {
              this.FormDataOne.domain_code.push(item.domainName)
            })
            this.FormDataOne.domain_code = [...new Set(this.FormDataOne.domain_code)]
          }

          if (languageC) {
            languageC.forEach(item => {
              this.FormDataOne.language.push(item.langName)
            })
            this.FormDataOne.language = [...new Set(this.FormDataOne.language)]
          }
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象

        }
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    return {
      auditStatus: null,
      FormDataOne: {
        mother_tongue: "",
        domain_code: [],
        language: [],
        region: "",
      },
      ruleFormDataOne: {
        mother_tongue: [{ required: true, message: '请选择母语', trigger: 'blur' },],
        domain_code: [{ required: true, message: '请选择擅长领域', trigger: 'blur' },],
        language: [{ required: true, message: '请选择擅长语言', trigger: 'blur' },],
        region: [{ required: true, message: '请选择从事年限', trigger: 'blur' },],
      },
      mother_tongueList: [], //母语
      domainList: [], //擅长领域
      domainCodeList: [], // 领域储存
      languageList: [], //擅长语言储存
      labelPosition: "left",
      isDis: true,
      dataObj: {},
      id: null,
    };
  },
  created () {
    this.getUserRegister()
    this.queryOptionList()
  },
  methods: {
    goEssentialInformation () {
      this.isDis = false
    },
    // 获取所有语言列表
    getUserRegister () {
      let that = this
      let url = `/v1/userRegister/queryAllLang`;
      //let instance = axios.create({ headers: { 'content-type': 'application/x-www-form-urlencoded' } });
      this.catReq1Service(url).then(function (response) {
        that.mother_tongueList = response.result
      })
    },
    // 获取领域列表
    queryOptionList () {
      let that = this
      let url = `/v1/userRegister/queryOptionList`;
      this.catReq1Service(url, {
        dataType: "domain"
      }).then(function (response) {
        that.domainList = response.result
      })
    },
    //领域
    handeleDomainCode (e) {
      let that = this
      that.domainCodeList = []
      // console.log(that.domainList)
      for (let i = 0; i < that.FormDataOne.domain_code.length; i++) {
        that.domainList.forEach(item => {
          if (item.dataValue == that.FormDataOne.domain_code[i]) {
            let obj = {}
            obj.domainCode = item.dataKey
            obj.domainName = item.dataDesc
            obj.userId = that.userId
            obj.id = item.id
            that.domainCodeList.push(obj)
          }
        })
      }
      // console.log(that.domainCodeList)
    },
    // 语言
    handeleLanguage (e) {
      let that = this
      that.languageList = []
      for (let i = 0; i < that.FormDataOne.language.length; i++) {
        that.mother_tongueList.forEach(item => {
          if (item.name == that.FormDataOne.language[i]) {
            let obj = {}
            obj.langCode = item.code
            obj.langName = item.name
            obj.userId = that.userId
            obj.id = item.id
            that.languageList.push(obj)
          }
        })
      }
    },
    // 保存
    async preservation () {
      let verify = true;
      this.$refs.ruleFormDataOne.validateField(["mother_tongue", "domain_code", "language", "region",], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      })
      if (verify) {
        let url = "/v1/userRegister/add_or_update_register_info"
        let myUser = JSON.parse(localStorage.getItem("myUser"))
        // 没改动的情况
        switch (this.FormDataOne.region) {
          case "1年以下":
            this.FormDataOne.region = "1"
            break;
          case "1-3年":
            this.FormDataOne.region = "2"
            break;
          case "3-5年":
            this.FormDataOne.region = "3"
            break;
          case "5-10年":
            this.FormDataOne.region = "4"
            break;
          default:
            break;
        }
        let params = {
          id: this.id,
          auditStatus: this.auditStatus === 0 ? 0 : 2,
          userId: myUser.id,
          dataOptions: this.domainCodeList, //擅长领域
          languages: this.languageList, //擅长语言
          motherTongue: this.FormDataOne.mother_tongue,
          translationTime: this.FormDataOne.region,
          certificateUrls: this.certificateUrls
        }
        const res = await this.catReq1Service(url, params)
        if (res.resultCode === "1") {
          this.isDis = true;
          this.$emit("succe", res.result)
          switch (this.FormDataOne.region) {
            case "1":
              this.FormDataOne.region = "1年以下"
              break;
            case "2":
              this.FormDataOne.region = "1-3年"
              break;
            case "3":
              this.FormDataOne.region = "3-5年"
              break;
            case "4":
              this.FormDataOne.region = "5-10年"
              break;
            default:
              break;
          }


        }
      }
    },
    // 取消
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      this.FormDataOne = { ...this.dataObj } // 解构对象，取消操作用解构对象
      // this.$refs["ruleFormDataOne"].resetFields();
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.language_ability {
  /*标题*/
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  .language_ability_isdsi {
    width: 100%;
    display: flex;
    i {
      color: red;
      display: inline-block;
      margin-right: 5px;
    }

    .left {
      width: 562px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .left_top {
        display: flex;
        align-items: center;
        // margin-left: 65px;
        font-weight: 400;
        color: #1c1c1d;
        font-size: 14px;
        margin-bottom: 20px;
        div {
          // margin-right: 53px;
        }
        .language_ability_isdsi_wrp {
          display: flex;
          align-items: center;
          span {
            text-align: center;
            width: 90px;
            height: 32px;
            line-height: 32px;
            background: rgba(17, 164, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .left_bottom {
        display: flex;
        align-items: center;
        // margin-left: 77px;
        font-weight: 400;
        color: #1c1c1d;
        font-size: 14px;
        div {
          // margin-right: 42px;
        }
        .language_ability_isdsi_wrp {
          display: flex;
          align-items: center;
          span {
            text-align: center;
            width: 90px;
            height: 32px;
            line-height: 32px;
            margin-right: 20px;
            background: rgba(17, 164, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
    .right {
      width: 582px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .right_top {
        display: flex;
        align-items: center;
        font-weight: 400;
        color: #1c1c1d;
        font-size: 14px;
        margin-bottom: 20px;
        div {
          margin-right: 42px;
        }
        .language_ability_isdsi_wrp {
          display: flex;
          align-items: center;
          span {
            text-align: center;
            width: 90px;
            height: 32px;
            line-height: 32px;
            margin-right: 20px;
            background: rgba(17, 164, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .right_bottom {
        display: flex;
        align-items: center;
        font-weight: 400;
        color: #1c1c1d;
        font-size: 14px;
        div {
          margin-right: 42px;
        }
        .language_ability_isdsi_wrp {
          display: flex;
          align-items: center;
          width: 320px;
          span {
            text-align: center;
            width: 90px;
            height: 32px;
            line-height: 32px;
            margin-right: 20px;
            background: rgba(17, 164, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  /*表单*/
  .el-form {
    display: flex;
    flex-wrap: wrap; //flex-grow
    /deep/.el-form-item {
      width: 40%;
      .el-select {
        .el-input {
          width: 208px !important;
        }
      }
    }
    .el-input {
      width: 202px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
